<div class="column-container empty-placeholder"
     [style.min-height.px]="minHeight"
     [style.padding-top.px]="paddingTop">
  <app-image-loading [alt]="message"
                     [src]="src"
                     [clickable]="false"
                     [targetWidth]="imgSize"
                     [targetHeight]="imgSize"/>
  <div class="empty-text"
       [class.mobile]="isMobile"
       [style.color]="fontColor"
       [style.margin-top.px]="textMarginTop()">
    {{message}}
  </div>
  @if (template) {
    <ng-container [ngTemplateOutlet]="template"/>
  }
</div>
